import React from 'react';
export function Footer() {
  return <footer className="w-full bg-text-brown py-12 text-center text-taupe/60 text-sm font-light" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-27">
        <p className="mb-4" data-id="element-28">
          © {new Date().getFullYear()} Menopause Master-Kit. Todos los derechos
          reservados.
        </p>
        <p className="max-w-2xl mx-auto text-xs opacity-70 leading-relaxed" data-id="element-29">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
      </div>
    </footer>;
}